"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cityInfo = cityInfo;
exports.cityList = cityList;
exports.cityListTree = cityListTree;
exports.cityListTree2 = cityListTree2;
exports.cityUpdate = cityUpdate;
exports.expressDelete = expressDelete;
exports.expressInfo = expressInfo;
exports.expressList = expressList;
exports.expressSave = expressSave;
exports.expressSyncApi = expressSyncApi;
exports.expressUpdate = expressUpdate;
exports.expressUpdateShow = expressUpdateShow;
exports.merchantExpressDelete = merchantExpressDelete;
exports.merchantExpressInfo = merchantExpressInfo;
exports.merchantExpressList = merchantExpressList;
exports.merchantExpressSave = merchantExpressSave;
exports.merchantExpressUpdate = merchantExpressUpdate;
exports.shippingDetete = shippingDetete;
exports.shippingFree = shippingFree;
exports.shippingRegion = shippingRegion;
exports.shippingSave = shippingSave;
exports.shippingTemplatesList = shippingTemplatesList;
exports.shippingUpdate = shippingUpdate;
exports.templateDetailApi = templateDetailApi;
exports.treeLevel3 = treeLevel3;
exports.treeLevel3ForSichuan = treeLevel3ForSichuan;
exports.updateStatus = updateStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 城市列表
function cityList(data) {
  // return request({
  //     url: '/admin/system/city/list',
  //     method: 'get',
  //     params: {...data },
  // });

  return (0, _requestMapi.default)({
    url: '/mapi/system/city/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 城市列表-两层
function cityListTree2() {
  return (0, _requestMapi.default)({
    url: '/mapi/system/city/list/treeLevel2',
    method: 'get'
  });
}

// 城市列表
function cityListTree() {
  return (0, _requestMapi.default)({
    url: '/mapi/system/city/list/tree',
    method: 'get'
  });
}
function treeLevel3() {
  return (0, _requestMapi.default)({
    url: '/mapi/system/city/list/treeLevel3',
    method: 'get'
  });
}

// 获取四川地区的三级树结构列表
function treeLevel3ForSichuan() {
  return (0, _requestMapi.default)({
    url: '/mapi/system/city/list/treeLevel3ForSichuan',
    method: 'get'
  });
}

// 城市修改状态
function updateStatus(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/system/city/update/status',
    method: 'post',
    params: _objectSpread({}, data)
  });
}

// 城市修改
function cityUpdate(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/system/city/update',
    method: 'post',
    params: _objectSpread({}, data)
  });
}

// 城市详情
function cityInfo(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/system/city/info',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 物流公司列表
function expressList(data) {
  return (0, _request.default)({
    url: '/admin/express/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 同步物流公司
function expressSyncApi() {
  return (0, _request.default)({
    url: '/admin/express/sync/express',
    method: 'post'
  });
}

// 物流公司修改状态
function expressUpdateShow(data) {
  return (0, _request.default)({
    url: '/admin/express/update/show',
    method: 'post',
    data: data
  });
}

// 物流公司 编辑
function expressUpdate(data) {
  return (0, _request.default)({
    url: '/admin/express/update',
    method: 'post',
    data: data
  });
}

// 新增物流公司
function expressSave(data) {
  return (0, _request.default)({
    url: '/admin/express/save',
    method: 'post',
    params: _objectSpread({}, data)
  });
}

// 删除物流公司
function expressDelete(data) {
  return (0, _request.default)({
    url: '/admin/express/delete',
    method: 'GET',
    params: _objectSpread({}, data)
  });
}

// 物流运费模板列表
function shippingTemplatesList(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/express/shipping/templates/list',
    url: '/mapi/order/shipping/templates/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 商户物流运费模板列表
function merchantExpressList(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/order/admin/merchantExpressTemplate/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 物流运费模板详情
function templateDetailApi(data) {
  return (0, _requestMapi.default)({
    //url: '/admin/express/shipping/templates/info',
    url: '/mapi/order/shipping/templates/info',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 物流运费模板详情
function merchantExpressInfo(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/order/admin/merchantExpressTemplate/info',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 物流运费模板包邮
function shippingFree(data) {
  return (0, _request.default)({
    url: '/admin/express/shipping/free/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 物流运费模板不包邮
function shippingRegion(data) {
  return (0, _request.default)({
    url: 'admin/express/shipping/region/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 物流运费模板新增
function shippingSave(data) {
  return (0, _requestMapi.default)({
    //url: 'admin/express/shipping/templates/save',
    url: '/mapi/order/shipping/templates/save',
    method: 'post',
    data: data
  });
}

// 物流运费模板新增(商户)
function merchantExpressSave(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/order/admin/merchantExpressTemplate/save',
    method: 'post',
    data: data
  });
}

// 物流运费模板更新
function shippingUpdate(data, id) {
  return (0, _requestMapi.default)({
    //url: 'admin/express/shipping/templates/update',
    url: '/mapi/order/shipping/templates/update',
    method: 'post',
    data: data,
    params: _objectSpread({}, id)
  });
}

// 物流运费模板更新（商户）
function merchantExpressUpdate(data, id) {
  return (0, _requestMapi.default)({
    url: '/mapi/order/admin/merchantExpressTemplate/update',
    method: 'post',
    data: data,
    params: _objectSpread({}, id)
  });
}

// 物流运费模板删除
function shippingDetete(data) {
  return (0, _requestMapi.default)({
    //url: 'admin/express/shipping/templates/delete',
    url: '/mapi/order/shipping/templates/delete',
    method: 'get',
    params: data
  });
}

// 物流运费模板删除（商户）
function merchantExpressDelete(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/order/admin/merchantExpressTemplate/delete',
    method: 'get',
    params: data
  });
}

// 物流公司详情
function expressInfo(data) {
  return (0, _request.default)({
    url: 'admin/express/info',
    method: 'get',
    params: _objectSpread({}, data)
  });
}